module.exports = __webpack_public_path__ + "assets/images/EURUNFIT200.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT200.png
// module id = 1375
// module chunks = 1